import React, { useEffect, useState, useRef, createElement, Component } from 'react';
import { Link } from 'react-router-dom';
import { TrendingUpIcon, CalendarIcon, UsersIcon, ExternalLinkIcon, BookmarkIcon, BriefcaseIcon, FilmIcon, Share2Icon, FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, CheckIcon, FilterIcon, SearchIcon, StarIcon, ClockIcon, UserIcon, MapPinIcon, TagIcon, HeartIcon, PlusIcon, ChevronDownIcon, MessageCircleIcon, HomeIcon, RssIcon } from 'lucide-react';
const SocialTrendingSection = () => {
  const [activeTab, setActiveTab] = useState('home-media');
  const [linkCopied, setLinkCopied] = useState(false);
  const [calendarDropdownOpen, setCalendarDropdownOpen] = useState<number | null>(null);
  const [shareDropdownOpen, setShareDropdownOpen] = useState<number | null>(null);
  const [followedSources, setFollowedSources] = useState<string[]>([]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Close dropdowns when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setCalendarDropdownOpen(null);
        setShareDropdownOpen(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const toggleFollow = (sourceId: string) => {
    setFollowedSources(prev => prev.includes(sourceId) ? prev.filter(id => id !== sourceId) : [...prev, sourceId]);
  };
  const homeFeedPosts = [{
    id: 1,
    source: 'Business Daily',
    sourceIcon: '',
    sourceType: 'website',
    timestamp: '4d',
    sponsored: false,
    title: 'Companies to hire more workers for festive season',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8FJvM2cibLEK7L8yg67b9L/WhatsApp_Image_2025-10-27_at_22.22.34_%281%29.jpg',
    excerpt: 'Kenyan companies are gearing up for the festive season by increasing their workforce...',
    url: 'https://businessdaily.co.ke',
    likes: 234,
    comments: 45
  }, {
    id: 2,
    source: 'glassnode',
    sourceIcon: '',
    sourceType: 'X (Twitter)',
    timestamp: '10h',
    sponsored: false,
    title: 'BTC: Stablecoin Supply Ratio (SSR) Oscillator',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/67t8YLYmK1fc44JGeEWSr8/4238aeaa-272d-4cc9-b48c-d682baf9e7a1.jpg',
    excerpt: 'The Stablecoin Supply Ratio (SSR) Oscillator continues to sit near cycle lows, indicating ample stablecoin liquidity relative to Bitcoin...',
    url: 'https://glassno.de/4osY1n7',
    likes: 1200,
    comments: 89
  }, {
    id: 3,
    source: 'Finelo',
    sourceIcon: '',
    sourceType: 'website',
    timestamp: '2d',
    sponsored: true,
    title: 'HOW TO BECOME A TRADER IN 28 DAYS?',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/b4WoD4YziaSEMFEKyXw8Qv/WhatsApp_Image_2025-10-27_at_22.22.34_%282%29.jpg',
    excerpt: 'Day Trading For Beginners. Transform your finances with personalized Trading Plan',
    url: 'https://finelo.com/trading',
    likes: 456,
    comments: 78
  }, {
    id: 4,
    source: 'Citizen Digital',
    sourceIcon: '',
    sourceType: 'website',
    timestamp: '1d',
    sponsored: false,
    title: 'Breaking News: Major Infrastructure Project Announced',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7oyS7nUzi1HAfHpk127Khu/WhatsApp_Image_2025-10-27_at_22.22.34.jpg',
    excerpt: 'Government unveils plans for new infrastructure development across the country...',
    url: 'https://citizen.digital',
    likes: 890,
    comments: 156
  }, {
    id: 5,
    source: 'Dawan Africa',
    sourceIcon: '',
    sourceType: 'Instagram',
    timestamp: '3h',
    sponsored: false,
    title: 'Cultural Heritage Celebration',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/un2TLPyNgDvsovhyzXiz5K/WhatsApp_Image_2025-10-27_at_22.22.35.jpg',
    excerpt: 'Join us in celebrating African culture and heritage through art, music, and community...',
    url: 'https://instagram.com/dawan.africa',
    likes: 567,
    comments: 92
  }];
  const socialPlatforms = [{
    id: 'twitter',
    name: 'X (Twitter)',
    icon: 'X',
    trending: 2,
    description: '#KenyaTechCommunity',
    metric: '1.2K tweets',
    url: 'https://twitter.com/search?q=%23KenyaTechCommunity'
  }, {
    id: 'tiktok',
    name: 'TikTok',
    icon: '♫',
    trending: 1,
    description: 'Cultural/Creative Movement',
    metric: '5.3K views',
    url: 'https://www.tiktok.com/tag/kenyalake'
  }, {
    id: 'linkedin',
    name: 'LinkedIn',
    icon: '💼',
    trending: 4,
    description: 'AI Kenya Community',
    metric: '3.1K posts',
    url: 'https://www.linkedin.com/groups/ai-kenya-community'
  }, {
    id: 'instagram',
    name: 'Instagram',
    icon: '📷',
    trending: 2,
    description: 'Serengeti Book Club',
    metric: '4.7K posts',
    url: 'https://www.instagram.com/explore/tags/serengetibookclub/'
  }, {
    id: 'whatsapp',
    name: 'WhatsApp',
    icon: '💬',
    trending: 1,
    description: 'The Social Tournamen...',
    metric: '320 messages',
    url: 'https://chat.whatsapp.com/'
  }, {
    id: 'facebook',
    name: 'Facebook',
    icon: '👥',
    trending: 3,
    description: 'Okoa Mombasa',
    metric: '2.1K members',
    url: 'https://www.facebook.com/groups/okoamombasa'
  }];
  const activePlatforms = [{
    name: 'X (Twitter)',
    description: '50K+ new members',
    url: 'https://twitter.com/search?q=%23Kenya'
  }, {
    name: 'LinkedIn',
    description: '30K+ professionals connected',
    url: 'https://www.linkedin.com/groups/kenya-professionals'
  }, {
    name: 'TikTok',
    description: '10.5M+ #KenyanLake views',
    url: 'https://www.tiktok.com/tag/kenyanlake'
  }];
  const whatsappCommunities = [{
    name: 'Kenya Tech Events',
    description: 'Tech events, meetups, and conferences in Kenya',
    url: 'https://whatsapp.com/channel/0029VabqbrFDuMRY9EPJcx0N',
    icon: '💻',
    type: 'tech'
  }, {
    name: 'SpaceYaTech',
    description: 'Tech community for developers and tech enthusiasts',
    url: 'https://whatsapp.com/channel/0029VaGvixqId7nOceC9TB2r',
    icon: '🚀',
    type: 'tech'
  }, {
    name: 'Mwango Capital',
    description: 'Business and professional networking community',
    url: 'https://whatsapp.com/channel/0029Va6Z1mEC6Zvfl8Wkhy2N',
    icon: '💼',
    type: 'business'
  }, {
    name: 'Jasiri Network',
    description: 'African diaspora community for professionals in the UK',
    url: 'https://whatsapp.com/channel/0029VaTkhRR3mFXz04C9Nb1s',
    icon: '🌍',
    type: 'diaspora'
  }, {
    name: 'My Wealth Guide KE',
    description: 'Financial guidance and investment tips for Kenyans',
    url: 'https://whatsapp.com/channel/0029VbAcW0M1Hsq5oXANMU0i',
    icon: '💰',
    type: 'finance'
  }, {
    name: 'Kenya Money Market Funds Portal',
    description: 'Financial insights and market analysis for investors',
    url: 'https://whatsapp.com/channel/0029VadiQCZLtOj4M8Wssi2E',
    icon: '📊',
    type: 'finance'
  }];
  const eventCategories = [{
    id: 'all',
    name: 'All Events',
    count: 245
  }, {
    id: 'entertainment',
    name: 'Entertainment',
    count: 37
  }, {
    id: 'business',
    name: 'Business & Networking',
    count: 85
  }, {
    id: 'health',
    name: 'Health & Fitness',
    count: 53
  }, {
    id: 'education',
    name: 'Education',
    count: 27
  }, {
    id: 'arts',
    name: 'Arts & Culture',
    count: 43
  }];
  const moviesData = [{
    title: 'Dune: Part Two',
    imdb: '8.8',
    rottenTomatoes: '92%',
    image: 'https://m.media-amazon.com/images/M/MV5BODI0YjNhNjUtYjM0My00MTUwLWFlYTMtMWI2NGUzYjNjNGQzXkEyXkFqcGdeQXVyMDM2NDM2MQ@@._V1_.jpg',
    url: 'https://centurycinemax.co.ke/movies/dune-part-two'
  }, {
    title: 'Kung Fu Panda 4',
    imdb: '7.3',
    rottenTomatoes: '84%',
    image: 'https://m.media-amazon.com/images/M/MV5BYzI0YjYxY2UtNzRkNS00MmZhLTkzNzMtODk4Y2M3MmE4NGJkXkEyXkFqcGdeQXVyMTUzMTg2ODkz._V1_.jpg',
    url: 'https://centurycinemax.co.ke/movies/kung-fu-panda-4'
  }, {
    title: 'Bob Marley: One Love',
    imdb: '6.8',
    rottenTomatoes: '72%',
    image: 'https://m.media-amazon.com/images/M/MV5BZDc4MzVkZTctMzU3Ni00M2I1LTkzMjYtZTFkNmE0MjJmMDUwXkEyXkFqcGdeQXVyMTA3MDk2NDg2._V1_.jpg',
    url: 'https://centurycinemax.co.ke/movies/bob-marley-one-love'
  }];
  const events = [{
    id: 1,
    name: 'Venture Wars',
    description: "Startup pitch competition featuring Kenya's most promising entrepreneurs",
    date: 'Aug 20, 2023',
    location: 'Nairobi, Kenya',
    ticketUrl: 'https://eventbrite.com/venture-wars'
  }, {
    id: 2,
    name: 'Yoga In The Park',
    description: 'Relax and rejuvenate in nature with guided yoga sessions',
    date: 'Aug 10, 2023',
    location: 'Karura Forest, Nairobi',
    ticketUrl: 'https://kenyabuzz.com/yoga-in-the-park'
  }];
  const shareContent = (platform: string, item: any, event?: React.MouseEvent) => {
    if (event) {
      event.stopPropagation();
    }
    const message = `See this ${activeTab === 'communities' ? 'community' : activeTab === 'movies' ? 'movie' : activeTab === 'events' ? 'event' : 'job'} which might interest you. I got it from www.jointoday.co.ke`;
    let url = '';
    switch (platform) {
      case 'whatsapp':
        url = `https://wa.me/?text=${encodeURIComponent(message + ' - ' + (item.name || item.title))}`;
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message + ' - ' + (item.name || item.title))}`;
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=https://jointoday.co.ke&quote=${encodeURIComponent(message + ' - ' + (item.name || item.title))}`;
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=https://jointoday.co.ke&summary=${encodeURIComponent(message + ' - ' + (item.name || item.title))}`;
        break;
      case 'instagram':
        // Instagram doesn't support direct sharing via URL, but we can copy to clipboard
        copyToClipboard(message + ' - ' + (item.name || item.title));
        alert('Content copied to clipboard. Open Instagram to share!');
        return;
      default:
        break;
    }
    if (url) window.open(url, '_blank');
    setShareDropdownOpen(null);
  };
  const addToCalendar = (eventId: number, calendarType: string, event?: React.MouseEvent) => {
    if (event) {
      event.stopPropagation();
    }
    const selectedEvent = events.find(e => e.id === eventId);
    if (!selectedEvent) return;
    // In a real implementation, this would generate the proper calendar links
    // For now, we'll just show an alert
    alert(`Adding "${selectedEvent.name}" to ${calendarType} calendar...`);
    setCalendarDropdownOpen(null);
  };
  const toggleCalendarDropdown = (eventId: number, event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setShareDropdownOpen(null); // Close share dropdown if open
    setCalendarDropdownOpen(calendarDropdownOpen === eventId ? null : eventId);
  };
  const toggleShareDropdown = (itemId: number, event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setCalendarDropdownOpen(null); // Close calendar dropdown if open
    setShareDropdownOpen(shareDropdownOpen === itemId ? null : itemId);
  };
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    });
  };
  return <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 mb-6" ref={dropdownRef} data-id="element-512">
      <div className="flex items-center mb-3" data-id="element-513">
        <TrendingUpIcon className="w-5 h-5 mr-2 dark:text-gray-300" data-id="element-514" />
        <h2 className="text-lg font-bold dark:text-gray-200" data-id="element-515">
          Trending Across Social Media
        </h2>
      </div>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4" data-id="element-516">
        See which platforms have the most active Kenyan communities right now
      </p>
      {/* Tab Navigation */}
      <div className="flex border-b border-gray-200 dark:border-gray-700 mb-4 overflow-x-auto" data-id="element-517">
        <button onClick={() => setActiveTab('home-media')} className={`py-2 px-4 text-sm font-medium ${activeTab === 'home-media' ? 'border-b-2 border-gray-800 dark:border-gray-200 dark:text-gray-200' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-518">
          <div className="flex items-center" data-id="element-519">
            <RssIcon className="w-4 h-4 mr-2" data-id="element-520" />
            Home Media
          </div>
        </button>
        <button onClick={() => setActiveTab('communities')} className={`py-2 px-4 text-sm font-medium ${activeTab === 'communities' ? 'border-b-2 border-gray-800 dark:border-gray-200 dark:text-gray-200' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-521">
          <div className="flex items-center" data-id="element-522">
            <UsersIcon className="w-4 h-4 mr-2" data-id="element-523" />
            Communities
          </div>
        </button>
        <button onClick={() => setActiveTab('movies')} className={`py-2 px-4 text-sm font-medium ${activeTab === 'movies' ? 'border-b-2 border-gray-800 dark:border-gray-200 dark:text-gray-200' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-524">
          <div className="flex items-center" data-id="element-525">
            <FilmIcon className="w-4 h-4 mr-2" data-id="element-526" />
            Movies & Shows
          </div>
        </button>
        <button onClick={() => setActiveTab('events')} className={`py-2 px-4 text-sm font-medium ${activeTab === 'events' ? 'border-b-2 border-gray-800 dark:border-gray-200 dark:text-gray-200' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-527">
          <div className="flex items-center" data-id="element-528">
            <CalendarIcon className="w-4 h-4 mr-2" data-id="element-529" />
            Events
          </div>
        </button>
        <button onClick={() => setActiveTab('jobs')} className={`py-2 px-4 text-sm font-medium ${activeTab === 'jobs' ? 'border-b-2 border-gray-800 dark:border-gray-200 dark:text-gray-200' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-530">
          <div className="flex items-center" data-id="element-531">
            <BriefcaseIcon className="w-4 h-4 mr-2" data-id="element-532" />
            Jobs
          </div>
        </button>
      </div>
      {/* Home Media Tab Content */}
      {activeTab === 'home-media' && <>
          <div className="mb-4" data-id="element-533">
            <div className="relative mb-4" data-id="element-534">
              <input type="text" placeholder="Search content from all sources..." className="w-full p-2 pl-10 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-800 dark:text-gray-200" data-id="element-535" />
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500 dark:text-gray-400" data-id="element-536" />
            </div>
            <p className="text-xs text-gray-600 dark:text-gray-400 mb-3" data-id="element-537">
              Your personalized feed from followed sources and trending content
            </p>
          </div>
          <div className="space-y-4" data-id="element-538">
            {homeFeedPosts.map(post => <div key={post.id} className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-539">
                <div className="flex items-center justify-between p-3 border-b border-gray-300 dark:border-gray-600" data-id="element-540">
                  <div className="flex items-center" data-id="element-541">
                    <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-542">
                      {post.sourceIcon ? <img src={post.sourceIcon} alt={post.source} className="w-full h-full rounded-full object-cover" data-id="element-543" /> : <UserIcon className="w-4 h-4 text-gray-500 dark:text-gray-400" data-id="element-544" />}
                    </div>
                    <div data-id="element-545">
                      <p className="text-sm font-medium dark:text-gray-200" data-id="element-546">
                        {post.source}
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-547">
                        {post.timestamp} • {post.sourceType}
                        {post.sponsored && <span className="ml-1 text-xs bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded dark:text-gray-300" data-id="element-548">
                            Sponsored
                          </span>}
                      </p>
                    </div>
                  </div>
                  <button onClick={() => toggleFollow(post.source)} className={`text-xs px-3 py-1 rounded-full ${followedSources.includes(post.source) ? 'bg-gray-200 dark:bg-gray-700 dark:text-gray-300' : 'border border-gray-300 dark:border-gray-600 dark:text-gray-200'}`} data-id="element-549">
                    {followedSources.includes(post.source) ? 'Following' : 'Follow'}
                  </button>
                </div>
                {post.image && <div className="relative" data-id="element-550">
                    <img src={post.image} alt={post.title} className="w-full h-48 object-cover" data-id="element-551" />
                  </div>}
                <div className="p-3" data-id="element-552">
                  <h3 className="font-medium mb-1 dark:text-gray-200" data-id="element-553">
                    {post.title}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-554">
                    {post.excerpt}
                  </p>
                  {post.url && <a href={post.url} target="_blank" rel="noopener noreferrer" className="text-xs text-gray-800 dark:text-gray-300 hover:underline flex items-center" data-id="element-555">
                      <ExternalLinkIcon className="w-3 h-3 mr-1" data-id="element-556" />
                      {post.url}
                    </a>}
                </div>
                <div className="flex items-center justify-between px-3 py-2 border-t border-gray-300 dark:border-gray-600" data-id="element-557">
                  <div className="flex items-center space-x-4" data-id="element-558">
                    <button className="flex items-center text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200" data-id="element-559">
                      <HeartIcon className="w-4 h-4 mr-1" data-id="element-560" />
                      {post.likes}
                    </button>
                    <button className="flex items-center text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200" data-id="element-561">
                      <MessageCircleIcon className="w-4 h-4 mr-1" data-id="element-562" />
                      {post.comments}
                    </button>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-563">
                    <button className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" data-id="element-564">
                      <BookmarkIcon className="w-4 h-4 text-gray-600 dark:text-gray-400" data-id="element-565" />
                    </button>
                    <div className="relative" data-id="element-566">
                      <button onClick={e => toggleShareDropdown(post.id, e)} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" data-id="element-567">
                        <Share2Icon className="w-4 h-4 text-gray-600 dark:text-gray-400" data-id="element-568" />
                      </button>
                      {shareDropdownOpen === post.id && <div className="absolute right-0 mt-1 w-36 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg z-10" data-id="element-569">
                          <button onClick={e => shareContent('whatsapp', post, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-570">
                            <span className="text-xs mr-2" data-id="element-571">📱</span>
                            WhatsApp
                          </button>
                          <button onClick={e => shareContent('twitter', post, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-572">
                            <TwitterIcon className="w-3 h-3 mr-2" data-id="element-573" />
                            Twitter
                          </button>
                          <button onClick={e => shareContent('facebook', post, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-574">
                            <FacebookIcon className="w-3 h-3 mr-2" data-id="element-575" />
                            Facebook
                          </button>
                          <button onClick={e => {
                    e.stopPropagation();
                    copyToClipboard(`${post.title} - ${post.excerpt}`);
                  }} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-576">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-577">
                              <rect width="14" height="14" x="8" y="8" rx="2" ry="2" data-id="element-578" />
                              <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" data-id="element-579" />
                            </svg>
                            Copy Link
                          </button>
                        </div>}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="flex justify-center mt-4" data-id="element-580">
            <button className="border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 text-sm dark:text-gray-200" data-id="element-581">
              Load More Content
            </button>
          </div>
        </>}
      {/* Communities Tab Content */}
      {activeTab === 'communities' && <>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 mb-4" data-id="element-582">
            {socialPlatforms.map(platform => <a key={platform.id} href={platform.url} target="_blank" rel="noopener noreferrer" className="border border-gray-300 dark:border-gray-600 rounded-lg p-2 text-center hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" data-id="element-583">
                <div className="w-10 h-10 mx-auto bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mb-1" data-id="element-584">
                  <span className="text-xl" data-id="element-585">{platform.icon}</span>
                </div>
                <p className="text-xs font-medium dark:text-gray-200" data-id="element-586">
                  {platform.name}
                </p>
                <div className="flex items-center justify-center text-xs text-gray-500 dark:text-gray-400" data-id="element-587">
                  <TrendingUpIcon className="w-3 h-3 mr-1" data-id="element-588" />
                  <span data-id="element-589">{platform.trending} trending</span>
                </div>
                <p className="text-xs text-gray-600 dark:text-gray-300 mt-1" data-id="element-590">
                  {platform.description}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-591">
                  {platform.metric}
                </p>
                <div className="flex items-center justify-center mt-2" data-id="element-592">
                  <ExternalLinkIcon className="w-3 h-3 mr-1" data-id="element-593" />
                  <span className="text-xs" data-id="element-594">Visit</span>
                </div>
              </a>)}
          </div>
          <h3 className="font-medium text-sm mb-2 dark:text-gray-200" data-id="element-595">
            WhatsApp Communities
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4" data-id="element-596">
            {whatsappCommunities.map((community, index) => <div key={index} className="border border-gray-300 dark:border-gray-600 rounded-lg p-3" data-id="element-597">
                <div className="flex items-center mb-2" data-id="element-598">
                  <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-3" data-id="element-599">
                    <span className="text-xl" data-id="element-600">{community.icon}</span>
                  </div>
                  <div data-id="element-601">
                    <h4 className="font-medium dark:text-gray-200" data-id="element-602">
                      {community.name}
                    </h4>
                    <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-603">
                      {community.description}
                    </p>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2" data-id="element-604">
                  <a href={community.url} target="_blank" rel="noopener noreferrer" className="text-xs border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1 flex items-center dark:text-gray-200" data-id="element-605">
                    Join on WhatsApp
                    <ExternalLinkIcon className="w-3 h-3 ml-1" data-id="element-606" />
                  </a>
                  <div className="relative" data-id="element-607">
                    <button onClick={e => toggleShareDropdown(index, e)} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" title="Share" data-id="element-608">
                      <Share2Icon className="w-4 h-4 dark:text-gray-300" data-id="element-609" />
                    </button>
                    {shareDropdownOpen === index && <div className="absolute right-0 mt-1 w-36 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg z-10" data-id="element-610">
                        <button onClick={e => shareContent('whatsapp', community, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-611">
                          <span className="text-xs mr-2" data-id="element-612">📱</span>
                          WhatsApp
                        </button>
                        <button onClick={e => shareContent('twitter', community, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-613">
                          <TwitterIcon className="w-3 h-3 mr-2" data-id="element-614" />
                          Twitter
                        </button>
                        <button onClick={e => shareContent('facebook', community, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-615">
                          <FacebookIcon className="w-3 h-3 mr-2" data-id="element-616" />
                          Facebook
                        </button>
                        <button onClick={e => {
                  e.stopPropagation();
                  copyToClipboard(`Check out ${community.name}: ${community.description}`);
                }} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-617">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-618">
                            <rect width="14" height="14" x="8" y="8" rx="2" ry="2" data-id="element-619" />
                            <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" data-id="element-620" />
                          </svg>
                          Copy Link
                        </button>
                      </div>}
                  </div>
                </div>
              </div>)}
          </div>
          <div className="border-t border-gray-200 dark:border-gray-700 pt-3" data-id="element-621">
            <div className="flex items-center mb-2" data-id="element-622">
              <span className="w-4 h-4 bg-gray-300 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-623">
                🔥
              </span>
              <span className="text-sm font-medium dark:text-gray-200" data-id="element-624">
                Most Active Platforms This Week
              </span>
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-625">
              {activePlatforms.map((platform, index) => <a key={index} href={platform.url} target="_blank" rel="noopener noreferrer" className="text-xs border border-gray-300 dark:border-gray-600 rounded-full px-2 py-1 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors dark:text-gray-200" data-id="element-626">
                  <span className="font-medium" data-id="element-627">{platform.name}</span> •{' '}
                  <span className="text-gray-600 dark:text-gray-400" data-id="element-628">
                    {platform.description}
                  </span>
                </a>)}
            </div>
          </div>
        </>}
      {/* Movies Tab Content */}
      {activeTab === 'movies' && <>
          <div className="mb-4" data-id="element-629">
            <div className="flex justify-between items-center mb-2" data-id="element-630">
              <h3 className="font-medium dark:text-gray-200" data-id="element-631">Now Showing</h3>
              <Link to="/movies" className="text-xs border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1 dark:text-gray-200" data-id="element-632">
                View All Movies
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-633">
              {moviesData.map((movie, index) => <div key={index} className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-634">
                  <div className="h-40 bg-gray-200 dark:bg-gray-700 border-b border-gray-300 dark:border-gray-600 relative" data-id="element-635">
                    {movie.image && <img src={movie.image} alt={movie.title} className="w-full h-full object-cover" data-id="element-636" />}
                  </div>
                  <div className="p-3" data-id="element-637">
                    <h4 className="font-bold mb-1 dark:text-gray-200" data-id="element-638">
                      {movie.title}
                    </h4>
                    <div className="flex items-center text-xs space-x-3 mb-2" data-id="element-639">
                      <span className="bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded dark:text-gray-200" data-id="element-640">
                        IMDb: {movie.imdb}
                      </span>
                      <span className="bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded dark:text-gray-200" data-id="element-641">
                        RT: {movie.rottenTomatoes}
                      </span>
                    </div>
                    <div className="flex justify-between items-center" data-id="element-642">
                      <a href={movie.url} target="_blank" rel="noopener noreferrer" className="text-xs bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-3 py-1 rounded-md" data-id="element-643">
                        Buy Ticket
                      </a>
                      <div className="relative" data-id="element-644">
                        <button onClick={e => toggleShareDropdown(index, e)} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" title="Share" data-id="element-645">
                          <Share2Icon className="w-4 h-4 dark:text-gray-300" data-id="element-646" />
                        </button>
                        {shareDropdownOpen === index && <div className="absolute right-0 mt-1 w-36 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg z-10" data-id="element-647">
                            <button onClick={e => shareContent('whatsapp', movie, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-648">
                              <span className="text-xs mr-2" data-id="element-649">📱</span>
                              WhatsApp
                            </button>
                            <button onClick={e => shareContent('twitter', movie, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-650">
                              <TwitterIcon className="w-3 h-3 mr-2" data-id="element-651" />
                              Twitter
                            </button>
                            <button onClick={e => shareContent('facebook', movie, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-652">
                              <FacebookIcon className="w-3 h-3 mr-2" data-id="element-653" />
                              Facebook
                            </button>
                            <button onClick={e => {
                      e.stopPropagation();
                      copyToClipboard(`Check out ${movie.title} - IMDb: ${movie.imdb}, RT: ${movie.rottenTomatoes}`);
                    }} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-654">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-655">
                                <rect width="14" height="14" x="8" y="8" rx="2" ry="2" data-id="element-656" />
                                <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" data-id="element-657" />
                              </svg>
                              Copy Link
                            </button>
                          </div>}
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="flex justify-center" data-id="element-658">
            <Link to="/movies" className="border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 text-sm dark:text-gray-200" data-id="element-659">
              Explore All Movies
            </Link>
          </div>
        </>}
      {/* Events Tab Content */}
      {activeTab === 'events' && <>
          <div className="mb-4" data-id="element-660">
            <h3 className="text-sm font-medium mb-2 dark:text-gray-200" data-id="element-661">
              Event Categories
            </h3>
            <div className="flex overflow-x-auto pb-2 space-x-2" data-id="element-662">
              {eventCategories.map(category => <Link key={category.id} to={`/events?category=${category.id}`} className={`flex items-center px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-full whitespace-nowrap text-sm ${category.id === 'all' ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'bg-white dark:bg-gray-800 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700'}`} data-id="element-663">
                  {category.id === 'all' && <span className="w-2 h-2 bg-white dark:bg-gray-800 rounded-full mr-1" data-id="element-664"></span>}
                  {category.name}{' '}
                  <span className="ml-1 text-xs" data-id="element-665">{category.count}</span>
                </Link>)}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-666">
            {events.map(event => <div key={event.id} className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-667">
                <h4 className="font-bold dark:text-gray-200" data-id="element-668">{event.name}</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1" data-id="element-669">
                  {event.description}
                </p>
                <div className="flex items-center mt-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-670">
                  <CalendarIcon className="w-3 h-3 mr-1" data-id="element-671" />
                  <span data-id="element-672">{event.date}</span>
                </div>
                <div className="flex justify-between items-center mt-3" data-id="element-673">
                  <div className="flex space-x-2" data-id="element-674">
                    <a href={event.ticketUrl} target="_blank" rel="noopener noreferrer" className="text-xs border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1 dark:text-gray-200" data-id="element-675">
                      Get Tickets
                    </a>
                    <div className="relative" data-id="element-676">
                      <button onClick={e => toggleCalendarDropdown(event.id, e)} className="text-xs border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1 flex items-center dark:text-gray-200" data-id="element-677">
                        <CalendarIcon className="w-3 h-3 mr-1" data-id="element-678" />
                        Add to Calendar
                        <ChevronDownIcon className="w-3 h-3 ml-1" data-id="element-679" />
                      </button>
                      {calendarDropdownOpen === event.id && <div className="absolute left-0 mt-1 w-40 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg z-10" data-id="element-680">
                          <button onClick={e => addToCalendar(event.id, 'Google Calendar', e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-gray-200" data-id="element-681">
                            Google Calendar
                          </button>
                          <button onClick={e => addToCalendar(event.id, 'Apple Calendar', e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-gray-200" data-id="element-682">
                            Apple Calendar
                          </button>
                          <button onClick={e => addToCalendar(event.id, 'Outlook', e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-gray-200" data-id="element-683">
                            Outlook
                          </button>
                          <button onClick={e => addToCalendar(event.id, 'Yahoo Calendar', e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-gray-200" data-id="element-684">
                            Yahoo Calendar
                          </button>
                        </div>}
                    </div>
                  </div>
                  <div className="relative" data-id="element-685">
                    <button onClick={e => toggleShareDropdown(event.id, e)} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" title="Share" data-id="element-686">
                      <Share2Icon className="w-4 h-4 dark:text-gray-300" data-id="element-687" />
                    </button>
                    {shareDropdownOpen === event.id && <div className="absolute right-0 mt-1 w-36 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg z-10" data-id="element-688">
                        <button onClick={e => shareContent('whatsapp', event, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-689">
                          <span className="text-xs mr-2" data-id="element-690">📱</span>
                          WhatsApp
                        </button>
                        <button onClick={e => shareContent('twitter', event, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-691">
                          <TwitterIcon className="w-3 h-3 mr-2" data-id="element-692" />
                          Twitter
                        </button>
                        <button onClick={e => shareContent('facebook', event, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-693">
                          <FacebookIcon className="w-3 h-3 mr-2" data-id="element-694" />
                          Facebook
                        </button>
                        <button onClick={e => {
                  e.stopPropagation();
                  copyToClipboard(`Check out ${event.name} on ${event.date} at ${event.location}`);
                }} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-695">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-696">
                            <rect width="14" height="14" x="8" y="8" rx="2" ry="2" data-id="element-697" />
                            <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" data-id="element-698" />
                          </svg>
                          Copy Link
                        </button>
                      </div>}
                  </div>
                </div>
              </div>)}
          </div>
          <div className="flex justify-center mt-4" data-id="element-699">
            <Link to="/events" className="border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 text-sm dark:text-gray-200" data-id="element-700">
              View All Events
            </Link>
          </div>
        </>}
      {/* Jobs Tab Content */}
      {activeTab === 'jobs' && <>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-701">
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-702">
              <h4 className="font-bold dark:text-gray-200" data-id="element-703">
                Software Developer
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1" data-id="element-704">
                Tech Innovations Kenya • Nairobi
              </p>
              <div className="flex items-center mt-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-705">
                <span className="bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded dark:text-gray-300" data-id="element-706">
                  Full-time
                </span>
                <span className="mx-2" data-id="element-707">•</span>
                <span data-id="element-708">KES 100,000 - 150,000</span>
              </div>
              <div className="flex justify-between items-center mt-3" data-id="element-709">
                <a href="https://example.com/job1" target="_blank" rel="noopener noreferrer" className="text-xs border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1 dark:text-gray-200" data-id="element-710">
                  Apply Now
                </a>
                <div className="relative" data-id="element-711">
                  <button onClick={e => toggleShareDropdown(1, e)} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" title="Share" data-id="element-712">
                    <Share2Icon className="w-4 h-4 dark:text-gray-300" data-id="element-713" />
                  </button>
                  {shareDropdownOpen === 1 && <div className="absolute right-0 mt-1 w-36 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg z-10" data-id="element-714">
                      <button onClick={e => shareContent('whatsapp', {
                  name: 'Software Developer Job'
                }, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-715">
                        <span className="text-xs mr-2" data-id="element-716">📱</span>
                        WhatsApp
                      </button>
                      <button onClick={e => shareContent('twitter', {
                  name: 'Software Developer Job'
                }, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-717">
                        <TwitterIcon className="w-3 h-3 mr-2" data-id="element-718" />
                        Twitter
                      </button>
                      <button onClick={e => shareContent('facebook', {
                  name: 'Software Developer Job'
                }, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-719">
                        <FacebookIcon className="w-3 h-3 mr-2" data-id="element-720" />
                        Facebook
                      </button>
                      <button onClick={e => {
                  e.stopPropagation();
                  copyToClipboard('Check out this Software Developer job at Tech Innovations Kenya in Nairobi');
                }} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-721">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-722">
                          <rect width="14" height="14" x="8" y="8" rx="2" ry="2" data-id="element-723" />
                          <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" data-id="element-724" />
                        </svg>
                        Copy Link
                      </button>
                    </div>}
                </div>
              </div>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-725">
              <h4 className="font-bold dark:text-gray-200" data-id="element-726">
                Marketing Manager
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1" data-id="element-727">
                Growth Strategies Ltd • Mombasa
              </p>
              <div className="flex items-center mt-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-728">
                <span className="bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded dark:text-gray-300" data-id="element-729">
                  Full-time
                </span>
                <span className="mx-2" data-id="element-730">•</span>
                <span data-id="element-731">KES 120,000 - 180,000</span>
              </div>
              <div className="flex justify-between items-center mt-3" data-id="element-732">
                <a href="https://example.com/job2" target="_blank" rel="noopener noreferrer" className="text-xs border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1 dark:text-gray-200" data-id="element-733">
                  Apply Now
                </a>
                <div className="relative" data-id="element-734">
                  <button onClick={e => toggleShareDropdown(2, e)} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" title="Share" data-id="element-735">
                    <Share2Icon className="w-4 h-4 dark:text-gray-300" data-id="element-736" />
                  </button>
                  {shareDropdownOpen === 2 && <div className="absolute right-0 mt-1 w-36 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg z-10" data-id="element-737">
                      <button onClick={e => shareContent('whatsapp', {
                  name: 'Marketing Manager Job'
                }, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-738">
                        <span className="text-xs mr-2" data-id="element-739">📱</span>
                        WhatsApp
                      </button>
                      <button onClick={e => shareContent('twitter', {
                  name: 'Marketing Manager Job'
                }, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-740">
                        <TwitterIcon className="w-3 h-3 mr-2" data-id="element-741" />
                        Twitter
                      </button>
                      <button onClick={e => shareContent('facebook', {
                  name: 'Marketing Manager Job'
                }, e)} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-742">
                        <FacebookIcon className="w-3 h-3 mr-2" data-id="element-743" />
                        Facebook
                      </button>
                      <button onClick={e => {
                  e.stopPropagation();
                  copyToClipboard('Check out this Marketing Manager job at Growth Strategies Ltd in Mombasa');
                }} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center dark:text-gray-200" data-id="element-744">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-745">
                          <rect width="14" height="14" x="8" y="8" rx="2" ry="2" data-id="element-746" />
                          <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" data-id="element-747" />
                        </svg>
                        Copy Link
                      </button>
                    </div>}
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center mt-4" data-id="element-748">
            <Link to="/jobs" className="border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 text-sm dark:text-gray-200" data-id="element-749">
              View All Jobs
            </Link>
          </div>
        </>}
      {/* Copied to clipboard notification */}
      {linkCopied && <div className="fixed bottom-4 right-4 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-4 py-2 rounded-md flex items-center z-50" data-id="element-750">
          <CheckIcon className="w-4 h-4 mr-2" data-id="element-751" />
          <span data-id="element-752">Copied to clipboard</span>
        </div>}
    </div>;
};
export default SocialTrendingSection;